import { render } from "./SimpleLayout.vue?vue&type=template&id=49e79f00"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__